import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Beaker, Calculator, Library, FlaskConical, AlertCircle, LogOut, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { AuthContext } from '@/App';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = React.useContext(AuthContext);

  const navigation = [
    { name: 'Tableau de bord', href: '/', icon: Beaker },
    { name: 'Simulateur', href: '/simulator', icon: Calculator },
    { name: 'Ingredients', href: '/ingredients', icon: FlaskConical },
    { name: 'Formules', href: '/formulas', icon: Library },
    { name: 'Depannage', href: '/troubleshooting', icon: AlertCircle },
  ];

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  return (
    <div className="min-h-screen bg-[#FBFBF9]">
      <nav className="bg-white border-b border-[#E5E5DF]">
        <div className="max-w-[1800px] mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-8">
              <div className="flex flex-col">
                <div className="flex items-center gap-3">
                  <Beaker className="h-8 w-8 text-[#2F4840]" />
                  <div>
                    <h1 className="text-2xl font-semibold heading-font text-[#2F4840]" data-testid="app-title">
                      R&D Cosmetique
                    </h1>
                    <p className="text-xs text-[#5C615E] font-medium">by DumaniLab</p>
                  </div>
                </div>
              </div>
              <div className="flex gap-2">
                {navigation.map((item) => {
                  const Icon = item.icon;
                  const isActive = location.pathname === item.href;
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      data-testid={`nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      <Button
                        variant={isActive ? 'default' : 'ghost'}
                        className={
                          isActive
                            ? 'bg-[#2F4840] text-white hover:bg-[#22352F]'
                            : 'text-[#5C615E] hover:bg-[#F6F7F6] hover:text-[#1A1C1B]'
                        }
                      >
                        <Icon className="h-4 w-4 mr-2" />
                        {item.name}
                      </Button>
                    </Link>
                  );
                })}
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2 px-3 py-2 bg-[#E4EDE9] rounded-sm" data-testid="user-info">
                <User className="h-4 w-4 text-[#2F4840]" />
                <span className="text-sm font-medium text-[#1A1C1B]">{user?.name}</span>
                <span className="text-xs text-[#5C615E] uppercase tracking-wide">{user?.role}</span>
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={handleLogout}
                className="border-[#E5E5DF] hover:bg-[#F6F7F6]"
                data-testid="logout-button"
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </nav>
      <main className="max-w-[1800px] mx-auto p-6 md:p-8">{children}</main>
    </div>
  );
};

export default Layout;
